import React from "react";

import { Flex, Loader } from "@aws-amplify/ui-react";
import Dialog from "@mui/material/Dialog";
import { I18n } from "aws-amplify/utils";
import { Skeleton } from "@mui/material";

// props
interface LoadingDialogProps {
  loadingMap: {
    [key: string]: boolean;
  };
}

const LoadingDialog: React.FC<LoadingDialogProps> = ({ loadingMap }) => {
  const loading = Object.values(loadingMap).some((loading) => loading);
  return (
    <>
      <Flex gap="1rem" direction="column" marginTop="1rem">
        <Skeleton variant="rectangular" width="40%" height="7vh" />
        <Skeleton variant="rectangular" width="100%" height="50vh" />
      </Flex>
      <Dialog open={loading}>
        <Loader variation="linear" ariaLabel={I18n.get("Loading")} />
      </Dialog>
    </>
  );
};

export default LoadingDialog;
